import { IFileDTO } from "../domain/models/dto/FileDTO";
import { IFile } from "../domain/models/File";
import { SimpleMapper } from "./SimpleMapper";

export class FileMapper extends SimpleMapper<IFile, IFileDTO> {
    protected fromDTOFields: string[] = [
        "id",
        "ownerId",
        "ownerType",
        "order",
        "purposeType",
        "filePath",
        "thumbnailPath",
        "fileType",
        "dataUrl",
        // "isCover",
        // "isGallery",
        "createdAt",
        "updatedAt",
    ];
    protected toDTOFields: string[] = [
        "id",
        "ownerId",
        "ownerType",
        "order",
        "purposeType",
        "fileType",
        "dataUrl",
    ];
}
